import React, { useEffect } from 'react';
import styles from './WelcomeScreen.scss';
import { useMediaQuery } from 'ca-hooks';
import {
  WelcomeScreenFooter,
  WelcomeScreenHeader,
  WelcomeSreenSurveyName,
  WelcomeScreenSettings,
  WelcomeScreenMessageContainer,
  WelcomeScreenStartForm,
} from './components';
import { WelcomeScreenDataProvider } from './providers';
import { WelcomeScreenProps } from './schema';
import { ampli, SurveyWelcomePageViewed } from '../../../../ampli';
import { sendAmpliEvent } from '../../../../ampli/sendAmpliEvent';
import { AmpliProvider } from '@cultureamp/analytics';

export const WelcomeScreen = (props: WelcomeScreenProps) => {
  useEffect(() => {
    const event = new SurveyWelcomePageViewed();
    sendAmpliEvent({
      ...event,
      group_properties: { Survey: props.aggregate_id },
    });
  }, [props.aggregate_id]);

  const desktop = useMediaQuery('(min-width:768px)');

  if (!props) {
    return <></>;
  }
  // This looks like a brand moment but has a few more capabilities around restructuring
  // the DOM to better suit mobile or desktop.

  return (
    <AmpliProvider ampli={ampli}>
      <WelcomeScreenDataProvider props={props}>
        <div className={styles.WelcomeScreenContainer}>
          <header>
            <WelcomeScreenHeader />
          </header>
          <main>
            <div className={styles.WelcomeScreenWrapper}>
              <div className={styles.WelcomeBodyContainer}>
                {desktop ? (
                  <>
                    <div className={styles.WelcomeMessageContainer}>
                      <WelcomeScreenMessageContainer />
                    </div>
                    <div
                      className={styles.WelcomeScreenDesktopContentContainer}
                    >
                      <div className={styles.WelcomeSurveyName}>
                        <WelcomeSreenSurveyName />
                      </div>
                      <div className={styles.WelcomeSettingsContainer}>
                        <WelcomeScreenSettings />
                      </div>
                      <WelcomeScreenStartForm />
                    </div>
                  </>
                ) : (
                  <>
                    <div className={styles.WelcomeSurveyName}>
                      <WelcomeSreenSurveyName />
                    </div>
                    <div className={styles.WelcomeMessageContainer}>
                      <WelcomeScreenMessageContainer />
                    </div>
                    <div className={styles.WelcomeSettingsContainer}>
                      <WelcomeScreenSettings />
                    </div>
                    {desktop && <WelcomeScreenStartForm />}
                  </>
                )}
              </div>
            </div>
          </main>
          <footer>
            <div className={styles.WelcomeFooterContainer}>
              {desktop ? (
                <WelcomeScreenFooter />
              ) : (
                <>
                  <WelcomeScreenFooter />
                  <WelcomeScreenStartForm />
                </>
              )}
            </div>
          </footer>
        </div>
      </WelcomeScreenDataProvider>
    </AmpliProvider>
  );
};
